import { colors, layers, radius, spacing } from '@lamimed/pantheon';
import styled from 'styled-components';

export const Container = styled.div`
  border-radius: ${radius.medium};
  height: fit-content;
  padding: ${spacing.medium};
  background-color: ${colors.light};
  z-index: ${layers.above};
`;
